import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { RouteProtector } from "./configs/routeProtector";
import { SignIn } from "./pages/authentication/signin";
import { Dashboard } from "./pages/dashboard";
import { Profile } from "./pages/usermanagement/profile";
import { PasswordReset } from "./pages/usermanagement/passwordreset";
import { PasswordReset as ResetPassword } from "./pages/authentication/passwordreset";
import { AuditTrail } from "./pages/report/audittrail";
import { UserRole } from "./pages/usermanagement/role";
import { AddRole } from "./pages/usermanagement/role/addrole";
import { EditRole } from "./pages/usermanagement/role/editrole";
import { AccessControl } from "./pages/usermanagement/accesscontrol";
import { Branch } from "./pages/configuration/branch";
import { AddBranch } from "./pages/configuration/branch/addbranch";
import { EditBranch } from "./pages/configuration/branch/editbranch";
import { MFIUser } from "./pages/usermanagement/mfiuser";
import { AddMFIUser } from "./pages/usermanagement/mfiuser/addmfiuser";
import { EditMFIUser } from "./pages/usermanagement/mfiuser/editmfiuser";
import { ChartOfAccount } from "./pages/accounting/chartofaccount";
import { AddChartOfAccount } from "./pages/accounting/chartofaccount/addchartofaccount";
import { EditChartOfAccount } from "./pages/accounting/chartofaccount/editchartofaccount";
import { SavingsProduct } from "./pages/configuration/savingsproduct";
import { AddSavingsProduct } from "./pages/configuration/savingsproduct/addsavingsproduct";
import { EditSavingsProduct } from "./pages/configuration/savingsproduct/editsavingsproduct";
import { CustomerList } from "./pages/customerservice/customerlist";
import { CreateCustomer } from "./pages/customerservice/customerlist/createcustomer";
import { EditCustomer } from "./pages/customerservice/customerlist/editcustomer";
import { ViewCustomer } from "./pages/customerservice/customerlist/viewcustomer";
import { CurrencyExchangeRate } from "./pages/configuration/currencyexchangerate";
import { AddCurrencyExchangeRate } from "./pages/configuration/currencyexchangerate/addcurrencyexchangerate";
import { EditCurrencyExchangeRate } from "./pages/configuration/currencyexchangerate/editcurrencyexchangerate";
import { CustomerApproval } from "./pages/approval/customerapproval";
import { CustomerApprovalAction } from "./pages/approval/customerapproval/customerapprovalaction";
import { PaymentMethod } from "./pages/configuration/paymentmethod";
import { AddPaymentMethod } from "./pages/configuration/paymentmethod/addpaymentmethod";
import { EditPaymentMethod } from "./pages/configuration/paymentmethod/editpaymentmethod";
import { TellerPostingApproval } from "./pages/approval/tellerpostingapproval";
import { AssignTellerManagement } from "./pages/usermanagement/assigntellermanagement";
import { AssignTeller } from "./pages/usermanagement/assigntellermanagement/assignteller";
import { EditAssignTeller } from "./pages/usermanagement/assigntellermanagement/editassignteller";
import { Vault } from "./pages/tellermanagement/vault";
import { ManageVault } from "./pages/tellermanagement/vault/managevault";
import { TransactionPosting } from "./pages/transaction/transactionposting";
import { GLBalancePosting } from "./pages/configuration/glbalanceposting";
import { GlGroupManagement } from "./pages/configuration/glgroupmanagement";
import { TierManagement } from "./pages/configuration/tiermanagement";
import { CreateTier } from "./pages/configuration/tiermanagement/createtier";
import { EditTier } from "./pages/configuration/tiermanagement/edittier";
import { SystemSettings } from "./pages/configuration/systemsettings";
import { AuthProvider } from "./context/authContext";
import { JournalEntry } from "./pages/accounting/journalentry";
import { TransactionReversal } from "./pages/accounting/transactionreversal";
import { AddJournalEntry } from "./pages/accounting/journalentry/addjournalentry";
import { SystemCharge } from "./pages/configuration/systemcharge";
import { AddSystemCharge } from "./pages/configuration/systemcharge/addsystemcharge";
import { EditSystemCharge } from "./pages/configuration/systemcharge/editsystemcharge";
import { LoanProducts } from "./pages/configuration/loanproduct";
import { AddLoanProduct } from "./pages/configuration/loanproduct/addloanproduct";
import { EditLoanProduct } from "./pages/configuration/loanproduct/editloanproduct";
import { LoanApplication } from "./pages/loanmanagement/loansetup/loanapplication";
import { BookLoan } from "./pages/loanmanagement/loansetup/bookloan";
import { EditLoanApplication } from "./pages/loanmanagement/loansetup/editloanapplication";
import { DraftLoanApplication } from "./pages/loanmanagement/loansetup/draftloanapplication";
import { PendingLoanApproval } from "./pages/approval/pendingloanapproval";
import { DisbursedLoanReport } from "./pages/report/disbursedloan";
import { GLTransactionsReport } from "./pages/report/gltransactions";
import { GroupList } from "./pages/customerservice/grouplist";
import { EditGroup } from "./pages/customerservice/grouplist/editgroup";
import { CreateGroup } from "./pages/customerservice/grouplist/creategroup";
import { PrintStatement } from "./pages/customerservice/printstatement";
import { AuthenticatedError } from "./pages/error/authenticated";
import { UnauthorizedError } from "./pages/error/unauthorized";
import { FundsTransfer } from "./pages/transaction/fundstransfer";
import { ManualChargePostingApproval } from "./pages/approval/manualchargepostingapproval";
import { CustomerReport } from "./pages/report/customerreport";
import { GroupReport } from "./pages/report/groupreport";
import { LoanPortfolioReport } from "./pages/report/loanportfolio";
import { OutstandingLoanBalanceReport } from "./pages/report/outstandingloanbalance";
import { IncomeStatementReport } from "./pages/report/incomestatement";

function App() {
	return (
		<BrowserRouter>
			<AuthProvider>
				<Routes>
					<Route path="/" element={<SignIn />} />
					<Route path="/reset-password" element={<ResetPassword />} />
					<Route element={<RouteProtector />}>
						<Route path="/dashboard" element={<Dashboard />} />

						{/* start of report routes */}
						<Route path="/report/audittrail" element={<AuditTrail />} />
						<Route
							path="/report/disbursedloan"
							element={<DisbursedLoanReport />}
						/>
						<Route
							path="/report/gltransactions"
							element={<GLTransactionsReport />}
						/>
						<Route path="/report/customer" element={<CustomerReport />} />
						<Route path="/report/group" element={<GroupReport />} />
						<Route
							path="/report/loanportfolio"
							element={<LoanPortfolioReport />}
						/>
						<Route
							path="/report/outstandingloanbalance"
							element={<OutstandingLoanBalanceReport />}
						/>
						<Route path="/report/group" element={<GroupReport />} />
						<Route
							path="/report/incomestatement"
							element={<IncomeStatementReport />}
						/>
						{/* end of report routes */}

						{/* start of user management routes */}
						<Route path="/profile" element={<Profile />} />
						<Route path="/passwordreset" element={<PasswordReset />} />
						<Route path="/usermanagement/role" element={<UserRole />} />
						<Route path="/usermanagement/addrole" element={<AddRole />} />
						<Route path="/usermanagement/role/:id" element={<EditRole />} />
						<Route
							path="/usermanagement/accesscontrol"
							element={<AccessControl />}
						/>
						<Route path="/usermanagement/mfiuser" element={<MFIUser />} />
						<Route path="/usermanagement/addmfiuser" element={<AddMFIUser />} />
						<Route
							path="/usermanagement/mfiuser/:id"
							element={<EditMFIUser />}
						/>
						<Route
							path="/usermanagement/teller"
							element={<AssignTellerManagement />}
						/>
						<Route
							path="/usermanagement/assignteller"
							element={<AssignTeller />}
						/>
						<Route
							path="/usermanagement/teller/:id"
							element={<EditAssignTeller />}
						/>
						{/* end of user management routes */}

						{/* start of configuration routes */}
						<Route path="/configuration/branch" element={<Branch />} />
						<Route path="/configuration/addbranch" element={<AddBranch />} />
						<Route path="/configuration/branch/:id" element={<EditBranch />} />
						<Route
							path="/configuration/savingsproduct"
							element={<SavingsProduct />}
						/>
						<Route
							path="/configuration/addsavingsproduct"
							element={<AddSavingsProduct />}
						/>
						<Route
							path="/configuration/savingsproduct/:id"
							element={<EditSavingsProduct />}
						/>
						<Route
							path="/configuration/currencyexchangerate"
							element={<CurrencyExchangeRate />}
						/>
						<Route
							path="/configuration/addcurrencyexchangerate"
							element={<AddCurrencyExchangeRate />}
						/>
						<Route
							path="/configuration/currencyexchangerate/:id"
							element={<EditCurrencyExchangeRate />}
						/>
						<Route
							path="/configuration/paymentmethod"
							element={<PaymentMethod />}
						/>
						<Route
							path="/configuration/addpaymentmethod"
							element={<AddPaymentMethod />}
						/>
						<Route
							path="/configuration/paymentmethod/:id"
							element={<EditPaymentMethod />}
						/>
						<Route
							path="/configuration/glbalanceposting"
							element={<GLBalancePosting />}
						/>
						<Route
							path="/configuration/glgroupmanagement"
							element={<GlGroupManagement />}
						/>
						<Route
							path="/configuration/tiermanagement"
							element={<TierManagement />}
						/>
						<Route path="/configuration/createtier" element={<CreateTier />} />
						<Route
							path="/configuration/tiermanagement/:id"
							element={<EditTier />}
						/>
						<Route
							path="/configuration/systemsettings"
							element={<SystemSettings />}
						/>
						<Route
							path="/configuration/systemcharge"
							element={<SystemCharge />}
						/>
						<Route
							path="/configuration/addsystemcharge"
							element={<AddSystemCharge />}
						/>
						<Route
							path="/configuration/systemcharge/:id"
							element={<EditSystemCharge />}
						/>
						<Route
							path="/configuration/loanproducts"
							element={<LoanProducts />}
						/>
						<Route
							path="/configuration/addloanproduct"
							element={<AddLoanProduct />}
						/>
						<Route
							path="/configuration/loanproduct/:id"
							element={<EditLoanProduct />}
						/>
						{/* end of configuration routes */}

						{/* start of accounting routes */}
						<Route
							path="/accounting/chartofaccount"
							element={<ChartOfAccount />}
						/>
						<Route
							path="/accounting/addchartofaccount"
							element={<AddChartOfAccount />}
						/>
						<Route
							path="/accounting/chartofaccount/:id"
							element={<EditChartOfAccount />}
						/>
						<Route path="/accounting/journalentry" element={<JournalEntry />} />
						<Route
							path="/accounting/addjournalentry"
							element={<AddJournalEntry />}
						/>
						<Route
							path="/accounting/transactionreversal"
							element={<TransactionReversal />}
						/>
						{/* end of accounting routes */}

						{/* start of customer service routes */}
						<Route
							path="/customerservice/customerlist"
							element={<CustomerList />}
						/>
						<Route
							path="/customerservice/addcustomerlist"
							element={<CreateCustomer />}
						/>
						<Route
							path="/customerlist/customer/:id/edit"
							element={<EditCustomer />}
						/>
						<Route
							path="/customerlist/customer/:id/view"
							element={<ViewCustomer />}
						/>
						<Route path="/customerservice/grouplist" element={<GroupList />} />
						<Route
							path="/customerservice/addgrouplist"
							element={<CreateGroup />}
						/>
						<Route
							path="/customerlist/group/:id/edit"
							element={<EditGroup />}
						/>
						<Route
							path="/customerservice/printstatement"
							element={<PrintStatement />}
						/>
						{/* end of customer service routes */}

						{/* start of approval routes */}
						<Route path="/approval/customer" element={<CustomerApproval />} />
						<Route
							path="/approval/customer/:id/view"
							element={<CustomerApprovalAction />}
						/>
						<Route
							path="/approval/tellerposting"
							element={<TellerPostingApproval />}
						/>
						<Route
							path="/approval/pendingloan"
							element={<PendingLoanApproval />}
						/>
						<Route
							path="/approval/manualchargeposting"
							element={<ManualChargePostingApproval />}
						/>
						{/* end of approval routes */}

						{/* start of teller management routes */}
						<Route path="/tellermanagement/vault" element={<Vault />} />
						<Route
							path="/tellermanagement/vault/posttransaction"
							element={<ManageVault />}
						/>
						{/* end of teller management routes */}

						{/* start of transactions routes */}
						<Route
							path="/transaction/posting"
							element={<TransactionPosting />}
						/>
						<Route
							path="/transaction/fundstransfer"
							element={<FundsTransfer />}
						/>
						{/* <Route
							path="/transaction/manualchargeposting"
							element={<ManualChargePosting />}
						/> */}
						{/* end of transactions routes */}

						{/* start of loan management routes */}
						<Route
							path="/loanmanagement/application"
							element={<LoanApplication />}
						/>
						<Route
							path="/loanmanagement/draftapplication"
							element={<DraftLoanApplication />}
						/>
						<Route
							path="/loanmanagement/application/:id/book"
							element={<BookLoan />}
						/>
						<Route
							path="/loanmanagement/application/:id/draft"
							element={<EditLoanApplication />}
						/>
						{/* end of loan management routes */}

						{/* start of unauthorized fall-back route */}
						<Route path="/unauthorized" element={<UnauthorizedError />} />
						{/* end of unauthorized fall-back route */}

						{/* start of catch-all route for authenticated users */}
						<Route path="*" element={<AuthenticatedError />} />
						{/* end of catch-all route for authenticated users */}
					</Route>
				</Routes>
			</AuthProvider>
		</BrowserRouter>
	);
}

export default App;
